// JS
import '../../custom/js/custom/index';
import '../../custom/js/custom/components/modal-agent-advisor';
import '../../custom/js/custom/components/modal-no-life-only';

// JS Custom

// Base SCSS
import '../../custom/scss/common/base.scss';
import '../../custom/scss/custom/layout.scss';

// Components SCSS
import '../../custom/scss/custom/components/hero/hero.scss';
import '../../custom/scss/custom/components/hero/hero-simple.scss';
import '../../custom/scss/custom/page-builder.scss';
import '../../custom/scss/custom/components/learning-center/learning-center-hero.scss';
import '../../custom/scss/custom/components/learning-center/learning-center-grid.scss';
import '../../custom/scss/custom/components/learning-center/learning-center-category.scss';
import '../../custom/scss/custom/components/learning-center/learning-center-top-articles.scss';
import '../../custom/scss/custom/components/learning-center/learning-center-quiz.scss';
import '../../custom/scss/custom/components/modal/modal-agent-advisor.scss';
import '../../custom/scss/custom/components/modal/modal-no-life-only.scss';